export type Lang =
  | 'en'
  | 'ru'
  | 'es'
  | 'fr'
  | 'de'
  | 'it'
  | 'pt'
  | 'tr'
  | 'pl'
  | 'cs'
  | 'ro'
  | 'bg'
  | 'uk'
  | 'nl'
  | 'hu'
  | 'el'
  | 'sv'
  | 'sr'
  | 'sq'
  | 'hr'
  | 'fi'
  | 'da'
  | 'no'
  | 'sk'
  | 'lt'
  | 'sl'
  | 'lv'
  | 'mk'
  | 'et'
  | 'bs'

export interface LangInfo {
  lang: Lang
  name: string
  localName: string
}

export const SUPPORTED_LANGUAGES: ReadonlyArray<Lang> = [
  'en',
  'ru',
  'es',
  'fr',
  'de',
  'it',
  'pt',
  'tr',
  'pl',
  'cs',
  'ro',
  'bg',
  'uk',
  'nl',
  'hu',
  'el',
  'sv',
  'sr',
  'sq',
  'hr',
  'fi',
  'da',
  'no',
  'sk',
  'lt',
  'sl',
  'lv',
  'mk',
  'et',
  'bs',
]

export const defaultLang: Lang = 'en'

const TITLES: Record<Lang, string> = {
  en: 'English',
  ru: 'Русский',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano',
  pt: 'Português',
  tr: 'Türkçe',
  pl: 'Polski',
  cs: 'Čeština',
  ro: 'Română',
  bg: 'Български',
  uk: 'Українська',
  nl: 'Nederlands',
  hu: 'Magyar',
  el: 'Ελληνικά',
  sv: 'Svenska',
  sr: 'Српски',
  sq: 'Shqip',
  hr: 'Hrvatski',
  fi: 'Suomi',
  da: 'Dansk',
  no: 'Norsk',
  sk: 'Slovenčina',
  lt: 'Lietuvių',
  sl: 'Slovenščina',
  lv: 'Latviešu',
  mk: 'Македонски',
  et: 'Eesti',
  bs: 'Bosanski',
}

export const isLanguageSupported = (rawLng: string): rawLng is Lang => {
  return SUPPORTED_LANGUAGES.includes(rawLng as Lang)
}

/**
 * Parse from tauri locale (e.g. "en-US" → "en")
 */
export const parse = (rawLng: string | undefined): Lang | undefined => {
  if (!rawLng) {
    return undefined
  }
  const normalized = rawLng.toLowerCase()
  const [lang] = normalized.split('-')
  return lang && isLanguageSupported(lang) ? lang : undefined
}

export const title = (lang: Lang): string => TITLES[lang]
